import Tooltip from "components/Tooltip/Tooltip";
import ForumIcon from "mdi-react/ForumIcon";
import styles from "./CommentCountBadge.module.scss";

/**
 * Inert display indicator that a record has comments, shown next to a
 * record-name link — mirroring how the provisioning-state dot decorates a record
 * name. Renders a small "forum" icon + the total comment count; renders nothing
 * when the count is 0 or absent (so uncommented records look unchanged).
 *
 * It is decoration only: it carries no click handler of its own and rides
 * whatever link/label it sits inside, so it reads as an indicator, not a button
 * (ui-design-principle-affordance-interactivity). Colours resolve through the
 * palette tokens (ui-design-principle-color-palette) in the accompanying module
 * stylesheet.
 *
 * (operator-task-fe-record-comment-indicator-on-links — phase (b), total count.
 * A later phase upgrades this to an unread count once the read-receipt UI from
 * operator-task-record-comments-ui-enhancements lands.)
 */
export const CommentCountBadge = ({
    count,
    className,
}: {
    count?: number | null;
    className?: string;
}) => {
    if (!count || count <= 0) {
        return null;
    }
    const label = `${count} comment${count === 1 ? "" : "s"}`;
    return (
        <Tooltip overlay={label} overlayStyle={{ zIndex: 20000 }}>
            <span className={`${styles.commentCountBadge} ${className ?? ""}`} aria-label={label}>
                <ForumIcon className={styles.icon} />
                <span className={styles.count}>{count}</span>
            </span>
        </Tooltip>
    );
};

export default CommentCountBadge;
